<div fxLayoutAlign.gt-sm="center center" fxLayout="column" #formContainer>

  <mat-card class="card mat-elevation-z0">
    <mat-card-content>

      <div fxLayout="column" fxLayoutAlign="center center center">

        <div fxLayout="row">
          <!--        Loading && Text Content -->
          <div fxLayout="column" #divElement ngStyle.lt-md="width:inherit;" [ngStyle.gt-sm]="contentWidth">
            <mat-card *ngIf="isLoading">
              <mat-progress-bar
                color="primary"
                mode="indeterminate">
              </mat-progress-bar>
            </mat-card>
          </div>
        </div>

        <!--                Foreign Languages-->
        <div fxLayout="row" *ngIf="hasForeignLanguage" style="margin-top:5px;" fxLayoutGap="5px">
          <mat-form-field appearance="outline"
                          style="width:50%; font-family: 'Century Gothic', sans-serif !important;">
            <mat-label>Επιλογή ξενης γλώσσας</mat-label>
            <mat-select [(ngModel)]="selectedLanguage">
              <mat-option *ngFor="let language of languages"
                          [value]="language">{{language.description}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline"
                          style="width:50%; font-family: 'Century Gothic', sans-serif !important;">
            <mat-label>Επίπεδο ξενης γλώσσας</mat-label>
            <mat-select>
              <mat-option *ngFor="let level of languageLevels"
                          [value]="level">{{level.level}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <!--                Deadline And PeopleAttendance-->
        <div fxLayout="row" fxFlex style="margin-top:5px; padding: 20px;" fxLayoutGap="5px">

          <div style="height:100px;" fxFlex="50">

            <div fxLayout="row" *ngIf="hasDeadline" style="margin-top:5px;">
              <mat-form-field appearance="outline"
                              style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
                <mat-label>Ημερομηνία προθεσμίας</mat-label>
                <label>
                  <input matInput [matDatepicker]="picker" [(ngModel)]="specificDate"
                         placeholder="Ημερομηνία προθεσμίας" readonly>
                </label>
                <mat-datepicker-toggle matSuffix [for]="picker" disabled="true"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

            </div>
          </div>

          <div fxFlex="50">
            <div fxLayout="column" style="margin-top: 5px;">
              <div fxLayout="row" *ngIf="hasMaxSlots">
                <mat-form-field appearance="outline"
                                style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
                  <mat-label>Πλήθος θέσεων</mat-label>
                  <label>
                    <input type="number" matInput readonly [value]="maxSlots" placeholder="Υπολοιπόμενες θέσεις">
                  </label>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>


        <!--      Consents Context-->
        <div *ngIf="!isLoading && requiresConsent"
             style=" margin-top:0px; width: 100%; padding: 10px 20px 20px 10px; border: 1px solid #0000003b; border-radius: 4px;"
             fxFlex>
          <p><span class="paragraph"></span><strong>Συγκατάθεση:</strong>
          </p>
          <p><span class="paragraph"></span>Με τη συμπλήρωση των κατωτέρω πεδίων, συναινώ στην επεξεργασία των
            δεδομένων
            υγείας
            μου που έχω καταχωρίσει
            ανωτέρω, για τους σκοπούς που αναφέρονται στην ενημέρωση που συνοδεύει την παρούσα συγκατάθεση.</p>
          <div style="padding-left:30px;">
            <div style="margin-top: 20px;padding-bottom: 10px;display: flex;
    flex-direction: column;
    align-items: center;">

              <form class="example-form" fxLayout="column" *ngIf="!has_full_info">

                <div fxLayout="row">
                  <mat-form-field class="example-full-width">
                    <label>
                      <input matInput placeholder="Ονοματεπώνυμο χρήστη" readonly [value]="getParentInfo('displayName')">
                    </label>
                  </mat-form-field>
                </div>

                <div fxLayout="row">
                  <mat-form-field class="example-full-width">
                    <label>
                      <input matInput placeholder="Ονοματεπώνυμο" readonly [value]="getChildInfo('displayName')">
                    </label>
                  </mat-form-field>
                </div>

                <div fxLayout="row">
                  <mat-form-field class="example-full-width">
                    <label>
                      <input matInput placeholder="Έτος γέννησης" readonly [value]="getChildInfo('birthday')">
                    </label>
                  </mat-form-field>
                </div>

              </form>

              <form class="example-form" fxLayout="column" *ngIf="has_full_info">

                <div fxLayout="row wrap" fxFlex="100" fxLayoutGap.lt-md="10px">

                  <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Επώνυμο" readonly [value]="getChildInfo('lastName')">
                      </label>
                    </mat-form-field>
                  </div>

                  <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Όνομα" readonly [value]="getChildInfo('firstName')">
                      </label>
                    </mat-form-field>
                  </div>

                  <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Όνομα Πατέρα" readonly [value]="getChildInfo('father_name')">
                      </label>
                    </mat-form-field>
                  </div>

                  <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Όνομα Μητέρας" readonly [value]="getChildInfo('mother_name')">
                      </label>
                    </mat-form-field>
                  </div>

                  <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Τόπος Γέννησης" readonly [value]="getChildInfo('place_of_birth')">
                      </label>
                    </mat-form-field>
                  </div>

                  <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Έτος Γέννησης" readonly [value]="getChildInfo('birthday')">
                      </label>
                    </mat-form-field>
                  </div>

                  <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Τόπος Κατοικίας" readonly [value]="getChildInfo('city')">
                      </label>
                    </mat-form-field>
                  </div>

                  <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Οδός" readonly [value]="getChildInfo('street')">
                      </label>
                    </mat-form-field>
                  </div>

                  <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Ταχ. Κώδικας" readonly [value]="getChildInfo('postal_code')">
                      </label>
                    </mat-form-field>
                  </div>

                  <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Αριθμός Ταυτότητας" readonly [value]="getChildInfo('id_number')">
                      </label>
                    </mat-form-field>
                  </div>

                  <div fxFlex.md="25" fxFlex.lt-md="25" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Ημ. Εκδ. Ταυτότητας" readonly [value]="getChildInfo('id_release_date')">
                      </label>
                    </mat-form-field>
                  </div>

                  <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                    <mat-form-field>
                      <label>
                        <input matInput placeholder="Τηλέφωνο" readonly [value]="getChildInfo('phone')">
                      </label>
                    </mat-form-field>
                  </div>
                </div>

              </form>

            </div>
          </div>

          <!--                  Consent Questions-->
          <div fxLayout="row" style="margin-top: 20px;border-bottom: 1px solid #0000003b;padding-bottom: 10px;">
            <div fxLayoutAlign="start center" fxFlex>
              <span><strong>Είδος συναίνεσης</strong></span>
            </div>
            <div fxLayoutAlign="end center" ngStyle.gt-sm="margin-right:40px;">
              <span><strong>Δε δίνω/Δίνω</strong></span>
            </div>
          </div>
          <div style="margin-top: 20px;border-bottom: 1px solid #0000003b;padding-bottom: 10px;"
               *ngFor="let item of consentSliderItems">
            <div style="display: inline-block;width: 80%;">
              <span><strong>{{item.title}}</strong></span>
            </div>
            <div style="float:right;width: 20%;display: flex;justify-content: center;">
              <mat-slide-toggle class="example-margin" [checked]="item.value" (change)="consentChange(item, $event)" disabled="false"
                                color="primary">
              </mat-slide-toggle>
            </div>
          </div>
          <!---->


        </div>


        <div *ngIf="mode === 'consent'" fxLayout="row" fxLayoutAlign="center center" class="actionsSection">
          <button mat-flat-button (click)="submitConsent()" color="primary">Ενημέρωση</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <ng-template #Loading>

  </ng-template>
</div>
